import { render, staticRenderFns } from "./prospectosAsignar.vue?vue&type=template&id=8af3dbfa&"
import script from "./prospectosAsignar.vue?vue&type=script&lang=js&"
export * from "./prospectosAsignar.vue?vue&type=script&lang=js&"
import style0 from "./prospectosAsignar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports